export const SHINSEI_LIST = "shinseiList";
